'use client';

import { Anchor, Box, Button, Container, Text, Title } from '@mantine/core';
import { useUserContext } from '@/contexts/UserContext';
import classes from './Welcome.module.css';

export function Welcome() {
  const { profile } = useUserContext();
  const admin = profile?.admin;
  const staff = profile?.is_staff;

  return (
    <>
      <Container mt={20} size={'xl'}>
        <Title className={classes.title} ta="center" mt={100}>
          Hope for Wildlife{' '}
          <Text
            inherit
            variant="gradient"
            component="span"
            gradient={{ from: 'black', to: 'green' }}
          >
            Dispatch
          </Text>
        </Title>
        {/* </Box> */}
        <Text c="dimmed" ta="center" size="xl" maw={800} mx="auto" mt="xl">
          This is an application for{' '}
          <Anchor
            href="https://www.hopeforwildlife.net/"
            size="lg"
            target="_blank"
            rel="noopener noreferrer"
          >
            Hope for Wildlife
          </Anchor>{' '}
          to manage wildlife dispatches.
        </Text>
        <Text c="dimmed" ta="center" size="xl" maw={800} mx="auto" mt="xl">
          Thank you for joining our team of dedicated volunteers. Your commitment to aiding injured
          and orphaned wildlife is crucial to our shared goal of nurturing and preserving our
          natural world. Together, we will continue to make a meaningful impact in the lives of
          wildlife and in our community.
        </Text>
        <Text c="dimmed" ta="center" size="xl" maw={800} mx="auto" mt="xl">
          If you encounter an injured animal, please call our dispatch line{' '}
          <Anchor href="tel:902-407-9453" size="lg">
            902-407-9453
          </Anchor>{' '}
          to report it. Your prompt action can make all the difference.
        </Text>
        {(admin || staff) && (
          <Box ta="center" mt="xl">
            <Button component="a" size="lg" href="/dispatch/create-dispatch" variant="filled">
              New Dispatch
            </Button>
          </Box>
        )}
      </Container>
    </>
  );
}
